import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {faPlus, faSadTear, faSmile} from '@fortawesome/free-solid-svg-icons';
import {environment} from '../../../../../../../environments/environment';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ProjectService} from '../../../../../../shared/services/project/project.service';
import {StatesService} from '../../../../../../shared/services/state/states.service';

@Component({
  selector: 'app-project-alarms-location-add-list',
  templateUrl: './project-alarms-location-add-list.component.html',
  styleUrls: ['./project-alarms-location-add-list.component.css']
})
export class ProjectAlarmsLocationAddListComponent implements OnInit {

  public activeLocationOnly = true;
  public displayedColumns: string[] = ['id', 'name', 'action', 'status'];
  public locations: MatTableDataSource<any>;
  public faPlus = faPlus;
  public faSadTear = faSadTear;
  public faSmile = faSmile;
  public showSpinner = false;
  @Input() projectId: number;
  @Input() alarmLocationsList: any[] = [];
  public pageSizeOptions = environment.pageSizeOptions;
  public pageSize = environment.pageSize;
  public typeAlarm: string;
  locationDeviceType: number;
  private alarmTypeWithLocationFilter = ['liris-location-alarm', 'threshold-alarm', 'operating-alarm', 'static-threshold-alarm', 'static-amplitude-alarm'];

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(public activeModal: NgbActiveModal,
              private projectService: ProjectService,
              private statesService: StatesService) {
  }

  ngOnInit() {
    this.initLocations();
  }

  addAllLocations() {
    this.locations.data.forEach((location) => {
      this.alarmLocationsList.push(location);
    });
    this.updateLocationList();
  }

  addLocationToAlarm(location: any) {
    this.alarmLocationsList.push(location);
    this.updateLocationList();
  }


  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.locations.filter = filterValue;
  }

  private initLocations() {
    this.showSpinner = true;
    const locationIdList: any[] = [];
    this.alarmLocationsList.forEach(user => {
      user.send_email = user.send_email === undefined ? false : user.send_email;
      user.send_sms = user.send_sms === undefined ? false : user.send_sms;
      user.send_voice = user.send_voice === undefined ? false : user.send_voice;
      locationIdList.push(user.id);
    });
    this.projectService.getProject(this.projectId, 'locations')
      .subscribe(
        (data: any) => {

          let locationTemp: any[] = [];
          if (this.alarmTypeWithLocationFilter.includes(this.typeAlarm)) {
            data.project_device_locations.forEach(d => {
              if (!locationIdList.includes(d.id)) {
                if (d.device_type !== undefined && this.filterLocationByAlarmType().includes(d.device_type.id)) {
                  if (this.activeLocationOnly) {
                    if (d.active === true) {
                      locationTemp.push(d);
                    }
                  } else {
                    locationTemp.push(d);
                  }
                }
              }
            });
          } else {
            locationTemp = data.project_device_locations.slice();
          }
          this.locations = new MatTableDataSource(locationTemp);
          this.locations.filter = null;
          this.locations.sort = this.sort;
          this.locations.paginator = this.paginator;
          this.showSpinner = false;
        }
        ,
        () => {
          this.showSpinner = false;

        }
      );
  }

  private filterLocationByAlarmType(): number[] {
    if (this.typeAlarm === 'liris-location-alarm') {
      return [1, 5, 6, 7, 13, 14, 17];
    }

    if (this.typeAlarm === 'threshold-alarm') {
      return [2, 3, 4];
    }

    if (this.typeAlarm === 'operating-alarm') {
      switch (this.locationDeviceType) {
        case 11:
          return [2, 3, 4];
        case 18:
          return [3];
        default:
          return [this.locationDeviceType];
      }
    }
    if (this.typeAlarm === 'static-threshold-alarm' || this.typeAlarm === 'static-amplitude-alarm') {
      return [1, 2, 3, 4, 5, 6, 7, 13, 14, 15, 16, 17, 19];
    }

    return [];
  }

  private updateLocationList() {
    const locationIdList: any[] = [];
    this.alarmLocationsList.forEach(location => {
      locationIdList.push(location.id);
    });
    const locationTemp: any[] = [];
    this.locations.data.forEach(d => {
      if (!locationIdList.includes(d.id)) {

        locationTemp.push(d);
      }
    });
    this.locations.data = locationTemp;
    this.statesService.reloadProjectAlarmsLocationRemove.next();
  }

  toggleActive() {
    this.activeLocationOnly = !this.activeLocationOnly;
    this.initLocations();
  }

  getSlideToggleText() {
    let activeText = '';
    this.activeLocationOnly ? activeText = 'ACTIVE_LOCATIONS_ONLY' : activeText = 'ALL_LOCATIONS';
    return activeText;
  }


}
